// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { SeverityValues } from 'thehive-sdk';
import { FillType } from '@Types';
import SecurityTag from '@Atoms/Info/SecurityTag/SecurityTag';
import { classList } from '@Helpers/className';

import './CaseNumber.scss';

interface CaseNumberProps {
    caseNumber: number;
    severity?: SeverityValues;
    className?: string;
    hashtag?: boolean;
    fillType?: FillType;
    onClick?: () => void;
}

const CaseNumber = ({
    caseNumber,
    severity = 1,
    className,
    hashtag = false,
    fillType = 'outline',
    onClick,
}: CaseNumberProps): ReactElement => (
    <SecurityTag
        type="severity"
        value={severity}
        content={`${hashtag ? '#' : ''}${caseNumber}`}
        className={classList('case-number', className)}
        fillType={fillType}
        onClick={onClick}
    />
);

export default CaseNumber;
